import React, { useRef, useEffect, useState } from "react";
import {
    NavItem,
    NavLink,
    DropdownList,
    StyledDropdownWrapper,
} from "./StyledComponents";
import { formatText } from "../../assets/store/formatText";

export const Dropdown = ({
    internalNavbarDataAttr,
    serviceLink,
    partsLink,
    accessoryLink,
    tiresLink,
    spanishLink,
    rebateLink,
    valvolineLink,
    nationalOffersLink,
    expressLink,
    bgLink,
    maintenanceMenuLink,
    navbarFontFamily,
    internal_navbar_theme,
    rowData,
    setVisible,
    setTransformSvg,
    isMobile,
}) => {
    const {
        navbar_color,
        navbar_button_background_color,
        navbar_button_background_hover_color,
        navbar_button_text_color,
        navbar_button_text_hover_color,
        font_weight,
        font_style,
        font_size,
    } = internal_navbar_theme;

    // hide the dropdown when user clicks outside of the element
    const wrapperRef = useRef(null);
    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setVisible(false);
            setTransformSvg(false);
        }
    };

    // Function to get the text for each dropdown item in the specials menu
    function getDropdownItemText(text) {
        let suffix =
            text === "National"
                ? "Offers"
                : text === "Maintenance"
                ? "Menu"
                : "Specials";
        return `${formatText(rowData, text)} ${formatText(rowData, suffix)}`;
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const dropdownLinks = [
        { type: "service", link: serviceLink },
        { type: "parts", link: partsLink },
        { type: "accessories", link: accessoryLink },
        { type: "tire", link: tiresLink },
        { type: "spanish", link: spanishLink },
        { type: "rebate", link: rebateLink },
        { type: "valvoline", link: valvolineLink },
        { type: "national", link: nationalOffersLink },
        { type: "express", link: expressLink },
        { type: "BG", link: bgLink },
        { type: "maintenance", link: maintenanceMenuLink },
    ].filter(
        (item) => item && item.link && item.link.link && item.link.link !== ""
    );
    const dropdownProps = {
        textColor: navbar_button_text_color ?? "black",
        buttonColor: navbar_button_background_color ?? "white",
        hoverTextColor: navbar_button_text_hover_color ?? "white",
        hoverButtonColor: navbar_button_background_hover_color ?? "gray",
        justifyContent: "center",
        alignItems: "start",
    };
    const internalNavDropdown = dropdownLinks.reduce(
        (container, linkObj, index) => {
            const key = `dropdown_${index + 1}`;
            const href = linkObj.link.link || "";
            const text =
                linkObj.type.replaceAll("_", " ").charAt(0).toUpperCase() +
                linkObj.type.slice(1);
            const location = `Internal Navbar Dropdown ${text} Specials`;
            const linkTarget = linkObj.link.open_link_in_new_tab;
            container[linkObj.type] = {
                content: (
                    <NavItem
                        classname="FODDropdownItem"
                        key={key}
                        style={{
                            justifyContent: "start",
                            alignItems: "baseline",
                        }}
                        {...dropdownProps}
                        data-testid={key}
                    >
                        <NavLink
                            href={String(href)}
                            style={{
                                padding: isMobile ? "2px 10px" : "8px 10px",
                            }}
                            {...internalNavbarDataAttr}
                            data-clicklocation={location}
                            data-clickurl={String(href)}
                            data-ascelementsubtype="dropdown"
                            className="FODGAInternalNavbarDropdownItem FODV5GAInternalNavbarClickEvent"
                            target={
                                linkTarget !== undefined
                                    ? linkTarget
                                        ? "_blank"
                                        : "_self"
                                    : "_self"
                            }
                        >
                            {getDropdownItemText(text)}
                        </NavLink>
                    </NavItem>
                ),
            };

            return container;
        },
        {}
    );

    const dropdownItems = Object.values(internalNavDropdown).map(
        (item, index) => (
            <React.Fragment key={index}>{item.content}</React.Fragment>
        )
    );

    return (
        <>
            {dropdownItems.length > 1 ? (
                <StyledDropdownWrapper
                    ref={wrapperRef}
                    style={{
                        fontFamily: navbarFontFamily,
                        fontWeight: font_weight,
                        fontStyle: font_style,
                        fontSize: font_size ? font_size : "1rem",
                        backgroundColor:
                            navbar_color ?? navbar_button_background_color,
                    }}
                    data-testid="internal-nav-dropdown"
                >
                    <DropdownList classname="FODDropDownList">
                        {dropdownItems}
                    </DropdownList>
                </StyledDropdownWrapper>
            ) : null}
        </>
    );
};
